
export const infiniteScrollContainerStyle = { 
  overflow: 'hidden', 
  width: '100%', 
  display: 'flex', 
  flexFlow: 'row wrap', 
  justifyContent: 'center', 
};
